import { useEffect, useMemo, useState } from "react"
import { AccordionIcon, DatePickerCustom, InputEntidad, InputLista, FormLabel, FormError, CheckboxButton, CheckboxButtonGroup } from "../../../../components/common"
import { OPERATION_MODE } from '@laramie/ui';
import { RelacionesPermitidas } from "./components"
import InputUsuario from "../../../../components/common/InputUsuario"
import {TIPS} from "../../../../consts/tips";
import { getDateNow } from "../../../../utils/convert";

const Definicion = ({ toggle, open, formValues, setFormValues, handleInputProxy, errorOf, otherValues, setOtherValues, params, setPendingChange, idUsuarioCreacion, tiposVinculoCuenta, utilizada, fechaPrimeraUtilizacion }) => {

    const [idTipoTributoTipoPlanPago, setIdTipoTributoTipoPlanPago] = useState(0);

    const bloqueada = params.mode === OPERATION_MODE.VIEW || utilizada

    const hoy = useMemo(() => getDateNow(), [])

    const fechaHastaVencida = formValues.fechaHasta && formValues.fechaHasta < hoy
    const fechaDesdeAnteriorAHoy = !formValues.fechaDesde || formValues.fechaDesde < hoy
    const minFechaHasta = params.mode === OPERATION_MODE.EDIT && !fechaHastaVencida && fechaDesdeAnteriorAHoy ? hoy : formValues.fechaDesde

    const fechaDesdePosteriorAPrimeraUtilizacion = fechaPrimeraUtilizacion && formValues.fechaDesde && formValues.fechaDesde > fechaPrimeraUtilizacion
    const maxFechaDesde = utilizada && fechaPrimeraUtilizacion && !fechaDesdePosteriorAPrimeraUtilizacion ? fechaPrimeraUtilizacion : undefined

    // el alta y la edición lo ubican en lugares distintos de la fila, pero es el mismo widget:
    // se define una vez para que los props no puedan quedar desalineados entre los dos modos
    const relacionesPermitidas = (
        <RelacionesPermitidas
            {...{params, tiposVinculoCuenta}}
            disabled={bloqueada}
            data={otherValues.pagosContadoDefinicionTipoVinculoCuenta}
            setData={data => {setOtherValues(prev => ({...prev, pagosContadoDefinicionTipoVinculoCuenta: data})); setPendingChange(true)}}
            idTipoTributo={formValues.idTipoTributo}
        />
    )

    return <>
        <div className='accordion-header'>
            <div className='row'>
                <div className="col-12" onClick={toggle}>
                    <div className='accordion-header-title'>
                        <AccordionIcon open={open} />
                        <h3 className={open ? 'active' : ''}>Definición</h3>
                    </div>
                </div>
            </div>
        </div>
        {(open &&
            <div className='accordion-body'>
                <div className='row form-basic'>

                    <div className="col-12 col-md-4 col-lg-2">
                        <FormLabel htmlFor="codigo" required>Código</FormLabel>
                        <input
                            name="codigo"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                            value={formValues.codigo}
                            onChange={handleInputProxy}
                            disabled={bloqueada}
                        />
                        <FormError message={errorOf('codigo')} />
                    </div>
                    <div className="col-12 col-md-8 col-lg-6">
                        <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                        <input
                            name="descripcion"
                            type="text"
                            placeholder=""
                            className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                            value={formValues.descripcion}
                            onChange={handleInputProxy}
                            disabled={params.mode === OPERATION_MODE.VIEW}
                        />
                        <FormError message={errorOf('descripcion')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="idTipoPlanPago" required>Convenio</FormLabel>
                        <InputEntidad
                            name="idTipoPlanPago"
                            tipName={TIPS.NAME.MODALS.TIPO_PLAN_PAGO_MODAL}
                            placeholder=""
                            className={`form-control ${errorOf('idTipoPlanPago') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoPlanPago}
                            onUpdate={({ target })  =>{
                                let idTipoTributo = 0;
                                if (target.row) {
                                    idTipoTributo = parseInt(target.row.idTipoTributo);
                                }
                                setIdTipoTributoTipoPlanPago(idTipoTributo);
                            }}
                            onChange={({ target })  =>{
                                let idTipoPlanPago = 0;
                                let idTipoTributo = 0;
                                if (target.row) {
                                    idTipoPlanPago = parseInt(target.row.id);
                                    idTipoTributo = parseInt(target.row.idTipoTributo);
                                }
                                setFormValues({...formValues,
                                    idTipoPlanPago: idTipoPlanPago,
                                    idTipoTributo: idTipoTributo
                                });
                                setPendingChange(true);
                                setIdTipoTributoTipoPlanPago(idTipoTributo);
                            }}
                            entidad="TipoPlanPago"
                            title="Convenio"
                            disabled={bloqueada}
                            memo={false}
                        />
                        <FormError message={errorOf('idTipoPlanPago')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="idTipoTributo" required>Tipo de tributo</FormLabel>
                        <InputLista
                            name="idTipoTributo"
                            placeholder=""
                            className={`form-control ${errorOf('idTipoTributo') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoTributo}
                            onChange={handleInputProxy}
                            lista="TipoTributo"
                            disabled={bloqueada || formValues.idTipoPlanPago === 0 || idTipoTributoTipoPlanPago > 0}
                        />
                        <FormError message={errorOf('idTipoTributo')} />
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <FormLabel htmlFor="idTipoVencimiento" required>Plazo de vencimiento</FormLabel>
                        <InputEntidad
                            name="idTipoVencimiento"
                            tipName={TIPS.NAME.MODALS.TIPO_VENCIMIENTO_PLAN_PAGO_MODAL}
                            placeholder=""
                            className={`form-control ${errorOf('idTipoVencimiento') ? 'is-invalid' : ''}`}
                            value={formValues.idTipoVencimiento}
                            onChange={handleInputProxy}
                            entidad="TipoVencimientoPlanPago"
                            title="Plazo de vencimiento"
                            disabled={bloqueada}
                            columns={[
                                { Header: 'Descripción', accessor: 'descripcion', width: '95%' }
                            ]}
                            filter={(row) => row.pagoContado}
                            memo={null}
                        />
                        <FormError message={errorOf('idTipoVencimiento')} />
                    </div>
                    {params.mode === OPERATION_MODE.NEW && relacionesPermitidas}

                    {params.mode !== OPERATION_MODE.NEW && <>
                        <div className="col-12 col-md-4 col-lg-2">
                            <FormLabel htmlFor="idEstadoPagoContadoDefinicion" required>Estado</FormLabel>
                            <InputLista
                                name="idEstadoPagoContadoDefinicion"
                                placeholder=""
                                className={`form-control ${errorOf('idEstadoPagoContadoDefinicion') ? 'is-invalid' : ''}`}
                                value={formValues.idEstadoPagoContadoDefinicion}
                                onChange={handleInputProxy}
                                lista="EstadoPagoContadoDefinicion"
                                disabled={params.mode === OPERATION_MODE.VIEW}
                            />
                            <FormError message={errorOf('idEstadoPagoContadoDefinicion')} />
                        </div>
                        {relacionesPermitidas}
                        <div className="col-12 col-md-6 col-lg-2">
                            <FormLabel htmlFor="fechaDesde" required>Fecha vigencia desde</FormLabel>
                            <DatePickerCustom
                                name="fechaDesde"
                                placeholder=""
                                className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                value={formValues.fechaDesde}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                                maxValue={maxFechaDesde}
                            />
                            <FormError message={errorOf('fechaDesde')} />
                        </div>
                        <div className="col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaHasta" className="form-label">Fecha vigencia hasta</label>
                            <DatePickerCustom
                                name="fechaHasta"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaHasta}
                                onChange={handleInputProxy}
                                disabled={params.mode === OPERATION_MODE.VIEW}
                                minValue={minFechaHasta}
                            />
                            <FormError />
                        </div>
                        <div className="col-12 col-md-2">
                            <FormLabel htmlFor="idViaConsolidacion" required>Vía de consolidación</FormLabel>
                            <InputLista
                                name="idViaConsolidacion"
                                placeholder=""
                                className={`form-control ${errorOf('idViaConsolidacion') ? 'is-invalid' : ''}`}
                                value={formValues.idViaConsolidacion}
                                onChange={handleInputProxy}
                                lista="ViaConsolidacion"
                                disabled={bloqueada}
                            />
                            <FormError message={errorOf('idViaConsolidacion')} />
                        </div>
                        <div className="col-12 col-md-6 col-lg-4">
                            <label htmlFor="idUsuarioCreacion" className="form-label">Usuario/a de creación</label>
                            <InputUsuario
                                name="idUsuarioCreacion"
                                placeholder=""
                                className="form-control"
                                value={ idUsuarioCreacion }
                                disabled={true}
                            />
                        </div>
                        <div className="col-12 col-md-6 col-lg-2">
                            <label htmlFor="fechaCreacion" className="form-label">Fecha de creación</label>
                            <DatePickerCustom
                                name="fechaCreacion"
                                placeholder=""
                                className="form-control"
                                value={formValues.fechaCreacion}
                                disabled
                            />
                        </div>
                        <div className="col-12 col-md-auto col-lg-2">
                            <CheckboxButtonGroup alignWithInputs>
                                <CheckboxButton
                                    name="cobraSellados"
                                    label="Incluye sellados"
                                    checked={formValues.cobraSellados}
                                    onChange={handleInputProxy}
                                    disabled={params.mode === OPERATION_MODE.VIEW}
                                />
                            </CheckboxButtonGroup>
                        </div>
                    </>}

                </div>
            </div>
        )}
    </>
}

export default Definicion
